import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/organizations/$id/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/accounts/$id", params });
  },
});
